export const SOFTWARE = [
    {
        name: "Kopfstations-Software DH8-Twin / DH8-Basis / DH4-Basis & Einzelumsetzer",
        desc: "Zur Programmierung der Kopfstation: DH8Twin inklusive aller Steckkarten. Zur Programmierung von Einzelumsetzern: S2-QAM, S2-QUAD, S2-COFDM, HDMI-QAM, HDMI-DVBT, AV-QAM, AV-DVBT, T2/C-QAM, T2/C-COFDM, T2/C-DVBS, SKU-Twin, HDMI-DVBS, AV-DVBS, HDMI-T-QAM, HDMI-T-DVBT, HDMI-AV-T-QAM, HDMI-AV-T-DVBT.",
        url: "/software/setup_DH8TwinProgrammer.zip",
    },
    {
        name: "STRO-Firmware — X-Serie / V16 / M2-Twin / M5-Twin / M8-Twin / M08-Twin",
        desc: "Firmware für die STRO-Modelle X-Serie, V16, M2-Twin, M5-Twin, M8-Twin und M08-Twin.",
        url: "http://www.astro-firmware.de/",
    },
];

export const MANUALS = [
    {
        category: "Kopfstationstechnik",
        items: [
            { name: "DH8-Basis (inkl. Steckkarten)", url: "/anleitungen/dh8-twin.pdf" },
            { name: "DH2-Twin", url: "/anleitungen/dh2-twin.pdf" },
            { name: "M2-Twin", url: "/anleitungen/m2-twin.pdf" },
        ],
    },
    {
        category: "Einzelumsetzer / Kopfstationstechnik",
        items: [
            { name: "HDMI3-QAM & HDMI3-DVBT", url: "/anleitungen/hdmix-qam-hdmix-dvbt.pdf" },
            { name: "HMQ1C", url: "/anleitungen/hmq1c.pdf" },
            { name: "HMQ1T", url: "/anleitungen/hmq1t.pdf" },
            { name: "HDMI-DVBS & AV-DVBS", url: "/anleitungen/hdmi-dvbs-av-dvbs.pdf" },
            { name: "AV-QAM & AV-DVBT", url: "/anleitungen/av-qam-av-dvbt.pdf" },
            { name: "USM-Twin4", url: "/anleitungen/usm-twin4.pdf" },
            { name: "USM3N", url: "/anleitungen/usm3n.pdf" },
            { name: "S2-COFDM", url: "/anleitungen/s2-cofdm.pdf" },
            { name: "SDU4-Twin & TDU3-Twin", url: "/anleitungen/sdu4-twin-tdu3-twin.pdf" },
            { name: "S2-QUAD", url: "/anleitungen/s2-quad.pdf" },
            { name: "S2-QAM", url: "/anleitungen/s2-qam.pdf" },
            { name: "T2/C-QAM & T2/C-COFDM", url: "/anleitungen/t2c-qam-t2c-cofdm.pdf" },
            { name: "T2/C-DVBS", url: "/anleitungen/t2c-dvbs.pdf" },
            { name: "SKU-TWIN", url: "/anleitungen/sku-twin.pdf" },
        ],
    },
    {
        category: "Einkabelsystem",
        items: [
            { name: "SAT-Convert 16", url: "/anleitungen/sat-convert-16.pdf" },
        ],
    },
    {
        category: "Antennenheizung",
        items: [
            { name: "Antennenheizung HSA1600 — 120-150 cm", url: "/anleitungen/hsa1600.pdf" },
            { name: "Antennenheizung HSAxxx — 85-90 cm", url: "/anleitungen/hsaxxx-antennenheizung.pdf" },
        ],
    },
    {
        category: "Infosystem",
        items: [
            { name: "Infomediaplayer", url: "/anleitungen/infomediaplayer.pdf" },
        ],
    },
];
